import { render, staticRenderFns } from "./YourStuffPage.vue?vue&type=template&id=6d22e47e&scoped=true"
import script from "./YourStuffPage.vue?vue&type=script&lang=js"
export * from "./YourStuffPage.vue?vue&type=script&lang=js"
import style0 from "./YourStuffPage.vue?vue&type=style&index=0&id=6d22e47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22e47e",
  null
  
)

export default component.exports